import { Component, OnInit } from '@angular/core';
import { MapService } from '../map.service';
import { TabService } from '../tab.service';

declare var bootstrap: any;

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-explorer',
  templateUrl: './explorer.component.html',
  styleUrls: ['./explorer.component.css']
})
export class ExplorerComponent implements OnInit {

  constructor(public tabService: TabService, public mapService: MapService) { }

  ngOnInit(): void {
    // Bootstrap tooltip initialization
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });       
  }

  ngAfterViewInit() {
    // Fix the map size
    setTimeout(() => {
      if (this.mapService.map) {
        this.mapService.map.updateSize();
      }
    }, 1000);
  }

}
